var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.parameterComponent)?_c('keep-alive',[_c(_vm.parameterComponent,{tag:"component",attrs:{"disabled":_vm.disabled}})],1):_c('div',[_vm._v("atopic dermatitis parameter not found")])
}
var staticRenderFns = []

export { render, staticRenderFns }